import { createSlice } from '@reduxjs/toolkit'

function getTenantId() {
    const hostnameParts = window.location.hostname.split(".");
    // Asume una estructura como "tenant.dominio.com"
    if (hostnameParts.length >= 3 && hostnameParts[0] !== "www") {
        return hostnameParts[0];
    }
    return null;
}

const initialState = {
    tenantId: getTenantId(),
    empresa: 0,
    departamento: ""
}

const ContextSlice = createSlice({
    name: 'ContextSlice',
    initialState,
    reducers: {
        setEmpresa(state, action) {
            state.empresa = action.payload
        },
        setDepartamento(state, action) {
            state.departamento = action.payload
        }
    }
});

export const { setEmpresa, setDepartamento} = ContextSlice.actions
export default ContextSlice.reducer;